import { render, staticRenderFns } from "./PeriodosEditar.vue?vue&type=template&id=6d508043&scoped=true&"
import script from "./PeriodosEditar.vue?vue&type=script&lang=js&"
export * from "./PeriodosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d508043",
  null
  
)

export default component.exports